/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { SeuilsApi } from '../../utils/api';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Seuil from './atom/Seuil';
import ErrorParameter from '../../components/common/ErrorParameter';
import { loaderDataComponent } from '../../utils/helper';

declare type BreakProps = {
  id?: string;
  token: string;
  mainInstallCode: string;
};

function FormBreak({ token, mainInstallCode }: BreakProps) {
  // déclaration des variables
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState(
    "une erreur s'est produite. Veuillez réessayer"
  );
  const toast = useRef<any>(null);

  //function to show toast
  const ShowToast = (severity: any, summary: any, detail: any) => {
    return toast.current?.show({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  };
  //Form fields on initialization with getParam value
  const [form, setForm] = React.useState<any>();
  //get api data
  const getSeuilParam = async () => {
    setLoading(true);
    try {
      const response = await SeuilsApi.getSeuilParameters(mainInstallCode);
      setForm({
        id: response.data.id,
        tresholdS1Max: response.data.tresholdS1max,
        tresholdS1Min: response.data.tresholdS1min,
        tresholdS2Max: response.data.tresholdS2max,
        tresholdS2Min: response.data.tresholdS2min,
        tresholdS3Max: response.data.tresholdS3max,
        tresholdS3Min: response.data.tresholdS3min,
        tresholdS4Max: response.data.tresholdS4max,
        tresholdS4Min: response.data.tresholdS4min,
      });

      if (response.status === 200 && response.data.length < 1) {
        setError(true);
        setTitle('Donnée inexistante');
        setErrorMessage(
          'Nous ne pouvons pas afficher la donnée car elle est inexistante'
        );
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  //Use effects
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getSeuilParam();
    }
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('token', token);
  }, [token]);

  const ShowSeuil = () => {
    let seuilContent: any = [];
    for (let i = 1; i <= 4; i++) {
      seuilContent.push(
        <div id={'seuil-' + i} key={i}>
          {form ? (
            <Seuil
              seuilTitle={'Saison ' + i}
              getSeuilMax={form[`tresholdS${i}Max`]}
              getSeuilMin={form[`tresholdS${i}Min`]}
              sendSeuilMax={(d: any) => {
                setForm((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`tresholdS${i}Max`]: d,
                  };
                });
              }}
              sendSeuilMin={(d: any) => {
                setForm((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`tresholdS${i}Min`]: d,
                  };
                });
              }}
            />
          ) : null}
        </div>
      );
    }
    return seuilContent;
  };

  const handleOnSubmit = async () => {
    setLoading(true);
    try {
      const response = await SeuilsApi.updateSeuilParameters(form);
      if (response.status === 200) {
        ShowToast('success', 'Succès', 'Données de paramètres enregistrées');
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement des données de paramètres"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container
      automatedTestId='seuil-global-container'
      className='seuil-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Form className='seuilForm' onSubmit={handleOnSubmit}>
        <Container className='seuilBodyContent'>
          <Word
            variant='p'
            textStyle='title'
            value='Variables PR'
            className='variable-title'
          />
          <Word
            variant='span'
            textStyle='normalReg'
            value='(temps, volume, nombre)'
            className='variable-subtitle'
          />
          {ShowSeuil()}
        </Container>
        <Container className='seuilButton'>
          {loaderDataComponent(loading)}
          {loading === false && <StyledSectionButton>
            <Button
              automatedTestId='btn-seuil-validation'
              className='param-btn'
              mode='plain'
            >
              <Word
                variant='span'
                textStyle='normalBold'
                value='Enregistrer les modifications'
              />
            </Button>
          </StyledSectionButton>}
        </Container>
      </Form>
      {error ? (
        <ErrorParameter
          message={errorMessage}
          title={title}
          IsVisible={error}
        />
      ) : null}
    </Container>
  );
}
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  margin-top: 50px;
`;
const Styles = createGlobalStyle`
.seuil-global-container.sds-reset-style{
  align-self: center;
  margin-left:auto;
  margin-right:auto;
  .pi{
    font-family: 'primeicons';    
  }
  .seuilForm{
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    .blueline{
    border: 0.5px solid #008BD2;
    background-color:  #008BD2;
    width: 43%;
    align-self: center;   
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .param-btn{
    align-self: center;
    margin-bottom: 15px;
  }
.seuilBodyContent{
  width: fit-content;
  flex-direction: column;
  justify-content: space-between;
  width: 912px;
  align-self: center;
  margin-left:auto;
  margin-right:auto;
  
  .variable-title,.variable-subtitle{
    text-align: center;
  }
  .variable-min,.variable-max{
    line-height:6;
    margin-left: 25px;
  }
  .variableBody{
    flex-direction: row;
    align-self: center;
  }
  input.p-inputtext.p-component.p-inputnumber-input{
    background-color: #FFFFFF;
    border: 1px solid #CCE8F6;
    border-radius: 5px;
    width: 95px;
    height: 43px;
    text-align: center;
    margin-left:10px;
    margin-top:20px;
    margin-bottom:20px;
    margin-right:20px;
  }
}
} 
}
`;

export default FormBreak;
